import { render, staticRenderFns } from "./contratos.vue?vue&type=template&id=241f8e09&scoped=true&"
import script from "./contratos.vue?vue&type=script&lang=js&"
export * from "./contratos.vue?vue&type=script&lang=js&"
import style0 from "./contratos.vue?vue&type=style&index=0&id=241f8e09&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241f8e09",
  null
  
)

export default component.exports